module.exports = __webpack_public_path__ + "img/bolo.550301fb.svg";